module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/radio_button_checked.73e678af.svg";